<mat-chip (click)="openExternalReference()">
  {{ referenceLabel }}
</mat-chip>
